import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_3M_79_3M_79',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_3m_79_3m_79_usd',
			EUR: 'simple_premium_3m_79_3m_79_eur',
			GBP: 'simple_premium_3m_79_3m_79_gbp',
			CAD: 'simple_premium_3m_129_3m_129_cad',
			AUD: 'simple_premium_3m_129_3m_129_aud',
			DKK: 'simple_premium_3m_679_3m_679_dkk',
			NOK: 'simple_premium_3m_1039_3m_1039_nok',
			SEK: 'simple_premium_3m_1039_3m_1039_sek',
			TRY: 'simple_premium_3m_2569_3m_2569_try',
			BRL: 'simple_premium_3m_319_3m_319_brl',
			MXN: 'simple_premium_3m_1299_3m_1299_mxn',
			ARS: 'simple_premium_3m_105389_3m_105389_ars',
			COP: 'simple_premium_3m_315999_3m_315999_cop',
			CLP: 'simple_premium_3m_79000_3m_79000_clp',
		},
		primer: 'prd_kvFfWmOs3D4D',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 3,
		intro_period_type: 'month',
		next_period_value: 3,
		next_period_type: 'month',
	},
	trial: {
		days: 90,
		priceMap: {
			USD: 79,
			EUR: 79,
			GBP: 79,
			CAD: 129,
			AUD: 129,
			DKK: 679,
			NOK: 1039,
			SEK: 1039,
			TRY: 2569,
			BRL: 319,
			MXN: 1299,
			ARS: 105389,
			COP: 315999,
			CLP: 79000,
		},
		originalPriceMap: {
			USD: 79,
			EUR: 79,
			GBP: 79,
			CAD: 129,
			AUD: 129,
			DKK: 679,
			NOK: 1039,
			SEK: 1039,
			TRY: 2569,
			BRL: 319,
			MXN: 1299,
			ARS: 105389,
			COP: 315999,
			CLP: 79000,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 3,
		priceMap: {
			USD: 79,
			EUR: 79,
			GBP: 79,
			CAD: 129,
			AUD: 129,
			DKK: 679,
			NOK: 1039,
			SEK: 1039,
			TRY: 2569,
			BRL: 319,
			MXN: 1299,
			ARS: 105389,
			COP: 315999,
			CLP: 79000,
		},
	},
	options: ($t, product, $tc) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.90_days.into_period_text'), // 'first quarter'
		explicitTermsIntervalText: $tc('common.duration.month.base', 3), // '3 months'
		billingSubtitlePeriodText: $t('pages.program.cheap_and_short.plans.90_days.into_period_text'), // 'three months'
		footerPeriodText: $t('pages.program.cheap_and_short.plans.90_days.period_text'), // '3-month'
		footerIntervalText: $t('pages.program.cheap_and_short.plans.90_days.sub_period_text'), // '3-month'
	}),
}
